module.exports = __webpack_public_path__ + "img/1-4.96f0c0db.jpg";